import axios from 'axios'
import { SERVER_API_URL } from '../Constants.js'

let api = axios.create({
  baseURL: SERVER_API_URL,
  //withCredentials: false,
  // headers: {
  //   Accept: 'application/json',
  //   'Content-Type': 'application/json',
  //   'X-Experience-API-Version': '1.0.3'
  // }
})

api.CancelToken = axios.CancelToken
api.isCancel = axios.isCancel

api.interceptors.request.use(
  config => {
    let headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Experience-API-Version': '1.0.3'
    }
    let token = localStorage.getItem('token')
    if (
      token != null &&
      token !== undefined &&
      token !== 'undefined' &&
      token !== ''
    ) {
      headers.Authorization = `Bearer ${token}`
    }
    config.headers = headers
    return config
  },

  error => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      store.commit('user/LOGOUT')
    }
    return Promise.reject(error)
  }
)

export default api
